/**
 * Issue #643 — the contact-number op (`customer/details/contact-number`,
 * Unibanks "Amend customer contact number") returns its business declines with
 * the gateway's GENERIC message ("Unable to Process Transaction"), so a
 * rejected landline change surfaced only the unreadable
 * "9235 — Unable to Process Transaction" beside the button. Per the #284/#286
 * rule we back the inline error with the authoritative error catalogue
 * (`requirements/unibanks-reference/API_Error_Codes.csv`, op "Amend customer
 * contact number") so EVERY documented decline code resolves to its real reason
 * — and an UNmapped code can never again show only the bare generic line
 * (backfilling the whole op, not hand-adding just 9235). Wording is verbatim
 * from the catalogue's `Error_Description` column.
 *
 * Shared by the two surfaces that render this op's declines — the landline leg
 * on Personal Details (SCRN-24) and the mobile leg on Mobile Number Update
 * (SCRN-26) — so both stay consistent (the #108/#414 "fix every surface that
 * shows the same data" rule).
 */
export const CONTACT_NUMBER_CODE_REASON: Record<string, string> = {
  '73': 'Invalid Mobile Phone No. Supplied',
  '153': 'Channel Closed',
  '154': 'Invalid Channel',
  '505': 'Zuser not found',
  '9101': 'Customer does not exist',
  '9102': 'Invalid card-customer relation',
  '9103': 'Invalid online card number / online business card number',
  '9104': 'Invalid card type for given online card',
  '9235': 'Invalid land line No. Supplied',
};

/**
 * The gateway's default, uninformative decline message for the contact-number
 * declines — "Unable to Process Transaction". When this (or no message) is all
 * the gateway gives, callers substitute the authoritative catalogue reason; a
 * genuinely specific gateway message is always preferred and shown verbatim.
 */
export const GENERIC_GATEWAY_MESSAGE = /^unable to process transaction\.?$/i;
